import { CmsTag } from "../../../types/cms/CmsTagType";
import { LocalizedImage } from "../../../types/cms/CmsImageType";
import { BaseEntity } from "../baseEntity";

export class CMSTag extends BaseEntity implements CmsTag {
  declare tagId: string;
  declare externalId: string | null;
  declare type: "provider" | "genre" | "other";
  declare name: string;
  declare images: LocalizedImage[];
  declare localizedInfo: {
    language: string;
    title: string;
    description: string;
  }[];

  constructor(tag: Partial<CmsTag> = {}) {
    super();
    Object.assign(this, tag);
  }

  getUniqueId(): string {
    return this.tagId;
  }

  getType(): string {
    return this.type;
  }

  getDisplayName(): string {
    return this.name || this.getUniqueId();
  }

  getImage(locale = "en") {
    if (this.images && this.images.length > 0) {
      const localeImage =
        this.images.find((img) => img.language === locale) || this.images[0];
      return localeImage.url;
    }

    return "";
  }

  serialize() {
    return {
      tagId: this.tagId,
      externalId: this.externalId,
      type: this.type,
      name: this.name,
      images: this.images,
      localizedInfo: this.localizedInfo,
      createdAt: this.createdAt,
      updatedAt: this.updatedAt,
    };
  }
}
